import React, { useState } from 'react';
import { Fragment } from "react"
import './blogs.module.css'
import { Helmet } from 'react-helmet';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { useRouteMatch } from "react-router";
import BlogChunk from './BlogChunk';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import Pagination from '../Newsroom/AllArticles/Pagination';
import { isAdmin } from '../../utils/localStorage';
import FlexFooter from '../Layout/FlexFooter';


const AllBlogs = ({blogs}) => {

    const match = useRouteMatch();
    const history = useHistory();
    const region = match.params.region;

    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState("");

    const isMobile = window.innerWidth < 768;


    const shortDesc = (blog) => {
        const stringLength = isMobile? 100 : 128
        return blog.content.substring(0, stringLength) + "...";
    }


    let itemsPerPage = 10;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const sortedBlogs =  blogs && blogs.filter((blog) =>
        blog.title.toLowerCase().includes(searchValue && searchValue.toLowerCase())
        ).sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate));
    const currentItems =
        sortedBlogs.slice(indexOfFirstItem, indexOfLastItem);
    const pageCount = Math.ceil(sortedBlogs.length / itemsPerPage);


    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
    };

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    };

    const AddBlogButton = () => {
        if (isAdmin())
            return <div className='addBlogButton' onClick={()=>history.push("newblog")}>
                <FontAwesomeIcon icon={faPlus}/> {isMobile? "" : " New blog"}
                </div>
        return null

    }

    return(
        <Fragment>
        <Helmet>
            <title>Autzu Blogs</title>
            <meta
            name="description"
            content="Rent a car to drive and earn on ridesharing platforms with no upfront payments or term-commitments. From only $7/hour, we provide a pre-qualified car and include maintenance, insurance, parking and 24/7 roadside assistance."
            />
        </Helmet>
            <div className='blogsPage container'>
                <div className='blogsContainer'>
                    <div className='allBlogs'>
                        <div className='allBlogsTitle'>
                            Blogs
                            <AddBlogButton/>
                            <input className='searchField' placeholder={`Search`} value={searchValue} onChange={handleSearchChange}/>
                        </div>
                        {currentItems.map((blog,index)=>{ return(
                        <BlogChunk
                            id={blog.id}
                            title={blog.title}
                            urlTitle={blog.urlTitle}
                            date={moment(blog.publicationDate).format("MMMM Do, YYYY")}
                            description={shortDesc(blog)}
                            comments={blog.comments.length}
                            timeToRead={` ${blog.readTime} minutes`}
                            image={blog.imageUrl}
                            region={region}
                        />)})}
                        {currentItems.length == 0?
                        <div className='noBlogText'>
                            No blogs found
                        </div>:""

                        }

                    </div>

                    {pageCount>1?
                        <Pagination
                            pageCount={sortedBlogs ? pageCount : 0}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            scrollToTop={scrollToTop}
                        />
                        :""
                    }
                </div>
            <FlexFooter region={region}/>
            </div>
        </Fragment>
    )
}

export default AllBlogs;


// WEBPACK FOOTER //
// ./src/components/Blogs/AllBlogs.js